import { useEffect, useRef, useState } from "react";
import { BiSolidTruck } from "react-icons/bi";
import { FaUser } from "react-icons/fa";
import { GrUserManager } from "react-icons/gr";
import { ImExit } from "react-icons/im";
import { MdManageAccounts, MdSpaceDashboard } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useSharedData from "../../../../../../hooks/useSharedData";
import style from "./LoginUserMenu.module.css";

function LoginUserMenu() {
  const navigate = useNavigate();

  const { user, isAgent, isSupervisor, isDistrictManager, isAdmin } =
    useSharedData();
  const token = localStorage.getItem("token");
  const city = user?.address?.city?.faName ?? "";
  const fullName = user?.name + " " + (user?.family ?? "");

  const [show, setShow] = useState(false);
  const userIcon = useRef(null);

  useEffect(() => {
    const handleClickOutside = e => {
      if (userIcon.current && !userIcon.current.contains(e.target)) {
        setShow(() => false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [userIcon]);

  const handleExit = () => {
    Swal.fire({
      icon: "error",
      title: "خروج",
      html: "<p style='font-size: 20px'>آیا مطمئن هستید ؟؟</p>",
      confirmButtonText: "بله",
      showCancelButton: true,
      cancelButtonText: "خیر",
      confirmButtonColor: "red",
      iconColor: "red",
    }).then(result => {
      if (result.isConfirmed) {
        navigate("/logout");
      }
    });
  };

  return (
    <div className="position-relative d-none d-sm-block" ref={userIcon}>
      <button className={style.user} onClick={() => setShow(cur => !cur)}>
        <FaUser />
      </button>
      {show && (
        <div className={style.userList}>
          <article className="d-flex column-gap-3">
            <img src="/avatar.png" alt="" className={style.img} />
            <div className="d-flex justify-content-center flex-column">
              <p className="mb-0 text-end fs-6 fw-semibold">{fullName}</p>
              <p className="mb-0 text-end">{city}</p>
            </div>
          </article>
          <div className={style.line} />
          <ul className={style.list}>
            {isAgent && (
              <li>
                <Link
                  to={`https://agent.avaex.ir/tokenLogin/${token}`}
                  className="text-decoration-none"
                >
                  <span>
                    <BiSolidTruck />
                  </span>
                  <span>پنل نمایندگی</span>
                </Link>
              </li>
            )}

            {isSupervisor && (
              <li>
                <Link
                  to={`https://agent.avaex.ir/tokenLogin/${token}`}
                  className="text-decoration-none"
                >
                  <span>
                    <GrUserManager />
                  </span>
                  <span>پنل سرپرستی</span>
                </Link>
              </li>
            )}

            {isDistrictManager && (
              <li>
                <Link
                  to={`https://agent.avaex.ir/tokenLogin/${token}`}
                  className="text-decoration-none"
                >
                  <span>
                    <MdManageAccounts />
                  </span>
                  <span>پنل مدیر منطقه</span>
                </Link>
              </li>
            )}

            {isAdmin && (
              <li>
                <Link
                  to={`https://dashboard.avaex.ir`}
                  className="text-decoration-none"
                >
                  <span>
                    <MdSpaceDashboard />
                  </span>
                  <span>داشبورد</span>
                </Link>
              </li>
            )}

            <li>
              <button onClick={handleExit}>
                <span>
                  <ImExit />
                </span>
                <span>خروج</span>
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default LoginUserMenu;
